import { useUserType } from 'src/contexts/userContext'
import { useCurrentVertical } from 'src/hooks'
import { useMeQuery } from 'src/queries/seller/me'
import { useLabelsQuery } from 'src/queries/shared'

export const useLabels = () => {
  const { isSeller } = useUserType()
  const { data: seller } = useMeQuery({ enabled: isSeller })
  const currentVerticalId = useCurrentVertical()?.id

  const { data: labels, isInitialLoading } = useLabelsQuery({
    queryParams: {
      id: seller?.labelIds,
      verticalId: currentVerticalId,
    },
    queryOptions: {
      enabled: (!!seller && seller.labelIds.length > 0) || !!currentVerticalId,
    },
  })

  return { labels, isInitialLoading }
}
